import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OBannerQuote as OBannerQuoteComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OBannerQuoteConfig = {
  emptyLabel: 'OBannerQuote',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-banner-quote`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OBannerQuote = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-banner-quote-comp"
      data-component-name="o-banner-quote"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OBannerQuoteConfig} {...props}>
        <OBannerQuoteComp {...props} />
      </EditableComponent>
    </div>
  );
};
